var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eqs-circular-progress",attrs:{"el-class":_vm.elClass}},[_c('v-progress-circular',{attrs:{"rotate":90,"value":_vm.valueProxy,"color":_vm.getColor,"size":40}},[_vm._v(" "+_vm._s(_vm.valueProxy)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }